import { MerchantFeeConfigResponse, MerchantFeeDetailsResponse } from 'api/payment'

export function instalmentDetailsMap(instalmentDetails): App.InstalmentDetails {
  return instalmentDetails ? {
    instalmentPaymentDetails: instalmentDetails.instalmentPaymentDetails.map(i => instalmentPaymentDetailsMap(i)),
    instalment_status: instalmentDetails.instalment_status,
    total_paid_amount: parseFloat(instalmentDetails.total_paid_amount),
    balance_amount: parseFloat(instalmentDetails.balance_amount),
    currency: instalmentDetails.currency,
    total_amount: parseFloat(instalmentDetails.total_amount),
    fk_orders: instalmentDetails.fk_orders,
    instalment_frequency: instalmentDetails.instalment_frequency,
    total_instalments_count: instalmentDetails.total_instalments_count,
    instalment_frequency_days: instalmentDetails.instalment_frequency_days,
    per_instalment_amount: parseFloat(instalmentDetails.per_instalment_amount),
    initial_payment_date: instalmentDetails.initial_payment_date,
    initial_payment_amount: parseFloat(instalmentDetails.initial_payment_amount),
    scheduled_instalment_dates: instalmentDetails.scheduled_instalment_dates,
    total_due_balance_auto_debit_failed_count: instalmentDetails.total_due_balance_auto_debit_failed_count,
    paid_instalments_count: instalmentDetails.paid_instalments_count,
    items: instalmentDetails.items,
    is_active: instalmentDetails.is_active,
    metadata: {
      external_ref: instalmentDetails.metadata.external_ref,
    },
    last_instalment_amount: parseFloat(instalmentDetails.last_instalment_amount),
    fk_customer: instalmentDetails.fk_customer,
  } : null
}

function instalmentPaymentDetailsMap(instalmentPaymentDetails): App.Instalment {
  return {
    id: instalmentPaymentDetails.id,
    instalments_number: instalmentPaymentDetails.instalments_number,
    instalment_amount: parseFloat(instalmentPaymentDetails.instalment_amount),
    instalment_due_date: instalmentPaymentDetails.instalment_due_date,
    instalment_paid_date: instalmentPaymentDetails.instalment_paid_date,
    currency: instalmentPaymentDetails.currency,
    instalment_status: instalmentPaymentDetails.instalment_status,
    due_balance_auto_debit_failed_count: instalmentPaymentDetails.due_balance_auto_debit_failed_count,
    created_at: instalmentPaymentDetails.created_at,
    metadata: {
      is_credit: instalmentPaymentDetails.metadata.is_credit,
      is_promo: instalmentPaymentDetails.metadata.is_promo,
    },
  }
}

export function merchantFeeConfigMap(result: MerchantFeeConfigResponse['result']): App.MerchantFeeConfig[] {
  return result.merchantFeeConfigs.map(merchantFeeConfig => ({
    id: merchantFeeConfig.id,
    name: merchantFeeConfig.name,
    percentage: merchantFeeConfig.percentage,
  }))
}

export function merchantFeeDetailsMap(result: MerchantFeeDetailsResponse['result']): App.MerchantFeeDetails[] {
  return result.merchantFeeDetails.map(merchantFeeDetail => ({
    fkItem: merchantFeeDetail.fk_item,
    amount: merchantFeeDetail.amount,
    metadata: {
      data: {
        shouldAutoRefund: merchantFeeDetail.metadata.data.shouldAutoRefund,
      },
    },
  }))
}
